export const SI_ACADEMY_URL: string = 'https://academy.salesintel.io';
export const SI_ADSINTEL_URL: string = 'https://salesintel.io/adsintel';
export const SI_PRICING_URL: string = 'https://salesintel.io/pricing';
export const SI_STATUS_URL: string = 'https://status.salesintel.io/';
export const SI_SUPPORT_HC_URL: string = 'https://support.salesintel.io/hc/en-us';
export const SI_SUPPORT_MAILTO_URL: string = 'mailto:support@salesintel.io';
export const SI_SUPPORT_URL: string = 'https://support.salesintel.io';

